import DynamicField from "./DynamicField";
import {useState, useEffect} from "react";

export default function MultipleGroupRenderer({question, questionAnswers, setQuestionAnswers,
                                                  validationErrors,  setValidationErrors, validateField}) {

    const [multipleItems, setMultipleItems] = useState(
        questionAnswers[question.code] || [
            { id: crypto.randomUUID() }
        ]
    );

    const addMultipleItem = () => {
        const updated = [
            ...multipleItems,
            { id: crypto.randomUUID() }
        ];

        setMultipleItems(updated);

        setQuestionAnswers({
            ...questionAnswers,
            [question.code]: updated
        });
    };

    const removeMultipleItem = (index) => {

        const updated = multipleItems.filter((_, i) => i !== index);

        setMultipleItems(updated);

        setQuestionAnswers({
            ...questionAnswers,
            [question.code]: updated
        });

        // ----- remove validation for deleted item -----
        setValidationErrors(prev => {

            const questionErrors = [...(prev[question.code] || [])];
            questionErrors.splice(index, 1);

            return {
                ...prev,
                [question.code]: questionErrors
            };
        });
    };


    const setMultipleFieldValue = (index, field) => {

        const updated = [...multipleItems];

        updated[index] = {
            ...updated[index],
            [field.code]: field.value
        };

        setMultipleItems(updated);

        setQuestionAnswers({
            ...questionAnswers,
            [question.code]: updated
        });

        // ----- VALIDATION -----
        const error = validateField(field, field.value);

        setValidationErrors(prev => {

            const questionErrors = [...(prev[question.code] || [])];

            const itemErrors = { ...(questionErrors[index] || {}) };

            if (error) {
                itemErrors[field.code] = error;
            } else {
                delete itemErrors[field.code];
            }

            questionErrors[index] = itemErrors;

            return {
                ...prev,
                [question.code]: questionErrors
            };
        });
    };

    useEffect(() => {
        setMultipleItems(questionAnswers[question.code] || []);
    }, [questionAnswers, question.code]);

    return <>
        {multipleItems.map((item, index) => (
            <div key={item.id} className="p-2 my-3 border border-gray-300 rounded-lg">
                <h2 className="my-3 ml-2 text-[#0a2540] text-x font-semibold flex justify-between items-center">
                    <span>{question.multipleTag + (index + 1)}</span>
                    <button
                        onClick={() => removeMultipleItem(index)}
                        className="inline-flex items-center gap-2 px-4 py-2 mr-2 bg-[#1C3353] text-white rounded-lg font-medium transition-all duration-300 hover:bg-gradient-to-b hover:from-[#F6D28B] hover:to-[#F1C169] hover:text-[#1C3353] hover:shadow-lg hover:shadow-yellow-500/30">
                        Remove
                    </button>
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {question.fields.map((field) => (
                        <div key={`${field.code}-${item.id}`}
                             className="p-2">
                            <DynamicField field={field}
                                          setFieldValue={(fieldValue) =>
                                              setMultipleFieldValue(index, fieldValue)}
                                          answer={multipleItems[index][field.code]}
                                          error={validationErrors?.[index]?.[field.code]}
                                          instanceId={item.id}
                                          questionAnswers = {questionAnswers}
                            />
                        </div>
                    ))}
                </div>
            </div>
        ))}

        <button
            onClick={addMultipleItem}
            className="inline-flex items-center gap-2 px-4 py-2 my-3 bg-[#1C3353] text-white rounded-lg font-medium transition-all duration-300 hover:bg-gradient-to-b hover:from-[#F6D28B] hover:to-[#F1C169] hover:text-[#1C3353] hover:shadow-lg hover:shadow-yellow-500/30 group">
            Add {question.multipleTag} {multipleItems.length + 1}
        </button>
    </>
}